import { Loader } from '@strapi/design-system/Loader';
import styles from './Preloader.module.scss';

export const Preloader = () => {
  return <Loader className={styles.Preloader}>Loading content...</Loader>;
};
